import { ICommand } from 'core-ts-types';
import { AccountModel } from 'data-ng-authentication';
import { CustomContentsServant, CustomTextQuery } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { PriorityFeedCapabilityConfiguration } from '../../configuration';
import { PronounsQuery } from '../../queries/pronouns_query';

export class PersonalGreetingController implements angular.IComponentController {
  private name: string;
  private message: string;
  private hasHoldsThatNeedAttention: boolean;
  private numberItems: number;
  private numberHolds: number;
  private showFreeDay: boolean;
  private isMobile: boolean;
  private heroUrl?: string;
  private heroImg: string;
  private possibleMessages = {
    noItems: 'Your day is free. Enjoy!',
    oneItem: 'Looks like you have something to do today.',
    manyItems: "You've got a few things going on today.",
    hasHoldsThatNeedAttention: 'Heads up! You have a hold needing attention.'
  };
  private defaultGreeting: string = 'Hey';

  constructor(
    private accountModel: AccountModel,
    private ngPriorityFeedCapabilityConfiguration: PriorityFeedCapabilityConfiguration,
    private loadPronounsCommand: ICommand,
    private getSTCConfigsCommand: ICommand,
    private openOpenableElementCommand: ICommand,
    private ngPronounsQuery: PronounsQuery,
    private ngCustomTextQuery: CustomTextQuery,
    private ngCustomContentsServant: CustomContentsServant
  ) {
    this.showFreeDay = false;
    this.isMobile = this.ngPriorityFeedCapabilityConfiguration.config.isMobile;
  }

  updateHeader() {
    this.showFreeDay = this.numberItems === 0;
    if (this.hasHoldsThatNeedAttention && this.numberHolds > 1) {
      this.message = `Heads up! You have ${this.numberHolds} holds needing attention.`;
    } else if (this.hasHoldsThatNeedAttention) {
      this.message = this.possibleMessages.hasHoldsThatNeedAttention;
    } else if (this.numberItems === 0) {
      this.message = this.possibleMessages.noItems;
    } else if (this.numberItems === 1) {
      this.message = this.possibleMessages.oneItem;
    } else {
      this.message = this.possibleMessages.manyItems;
    }
  }

  getStudentPronouns() {
    this.getSTCConfigsCommand().then((response: any) => {
      if (response.show_pronouns) {
        this.loadPronounsCommand(_4.get(this.accountModel, 'student_nk', ''));
      }
    });
  }

  openHelp() {
    this.openOpenableElementCommand('appSupportDrawer');
  }

  $onInit(): void {
    this.name = _4.get(this.accountModel, 'firstName', '');
    this.heroUrl = this.isMobile ? undefined : this.ngPriorityFeedCapabilityConfiguration.config.institutionMediaURL;
    this.heroImg = `url(${this.heroUrl ? this.heroUrl : 'res/dashboard-new.jpg'})`;
    this.hasHoldsThatNeedAttention = false;
    this.getStudentPronouns();
    this.ngCustomContentsServant.getButtonLabel('Schedule an Appointment');
  }
}

export class PersonalGreetingComponent implements angular.IComponentOptions {
  public templateUrl: string = 'capability-ng-priority-feed/src/components/personal_greeting/personal_greeting.html';
  public controller: any = PersonalGreetingController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    hasHoldsThatNeedAttention: '<',
    numberHolds: '<',
    numberItems: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-priority-feed/src/components/personal_greeting/personal_greeting.ts